import React from 'react';
import { AlertTriangle, RefreshCw, X } from 'lucide-react';
import { ErroApi } from '../../types/gerArquivos';

interface ErroDisplayProps {
  erro: ErroApi | null;
  onRetry?: () => void;
  onDismiss?: () => void;
  className?: string;
}

export function ErroDisplay({ erro, onRetry, onDismiss, className = '' }: ErroDisplayProps) {
  if (!erro) return null;

  return (
    <div className={`p-3 bg-red-600/10 border border-red-600/20 rounded-lg ${className}`}>
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 text-red-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-red-400 font-medium">{erro.mensagem}</p>
          {erro.detalhes && (
            <p className="text-xs text-red-300 mt-1">{erro.detalhes}</p>
          )}
          <p className="text-xs text-red-300 mt-1">Código: {erro.codigo}</p>
        </div>
        <div className="flex items-center gap-1 flex-shrink-0">
          {onRetry && (
            <button
              onClick={onRetry}
              className="p-1 text-red-400 hover:text-red-300 transition-colors"
              title="Tentar novamente"
              aria-label="Tentar novamente"
            >
              <RefreshCw className="w-3 h-3" />
            </button>
          )}
          {onDismiss && (
            <button
              onClick={onDismiss}
              className="p-1 text-red-400 hover:text-red-300 transition-colors"
              title="Fechar erro"
              aria-label="Fechar erro"
            >
              <X className="w-3 h-3" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
